export enum DataSourcesQueries {
  DataSources = 'dataSources',
  EmptyDataSources = 'emptyDataSources',
  DataStatus = 'dataStatus',
  DataSourcesWithError = 'dataSourcesWithError',
}
